import { cn } from "@/lib/class-control";

interface CalendarEventBoxProps {
  title: string;
  color?: "yellow" | "green" | "red" | "purple";
  onClick?: () => void;
  className?: string;
}

const colorMap = {
  yellow: "#F2C71E",
  green: "#13D480",
  red: "#DC4426",
  purple: "#7846FF",
} as const;

export function CalendarEventBox({ title, color = "purple", onClick, className }: CalendarEventBoxProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "box-border flex h-[47px] w-full items-end gap-[10px] p-[10px]",
        "cursor-pointer transition-opacity hover:opacity-90",
        className
      )}
      style={{ backgroundColor: colorMap[color] }}
      type="button"
    >
      <p className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left text-[12px] font-bold leading-normal text-white">
        {title}
      </p>
    </button>
  );
}
